import React from 'react';
import './FallingLeaves.css';

const LEAVES = ['🍂', '🍁', '🍂', '🍃'];

const FallingLeaves = () => {
  // Generate 25 leaves with randomized properties
  const leaves = Array.from({ length: 25 }, (_, i) => ({
    id: i,
    emoji: LEAVES[i % LEAVES.length],
    left: Math.random() * 100, // Random horizontal position (0-100%)
    animationDuration: 12 + Math.random() * 16, // 12-28 seconds
    animationDelay: Math.random() * 12, // 0-12 seconds delay
    size: 0.7 + Math.random() * 0.8, // Size multiplier
    opacity: 0.5 + Math.random() * 0.4, // 0.5-0.9
  }));

  return (
    <div className="halloween-leaves-container">
      {leaves.map((leaf) => (
        <div
          key={leaf.id}
          className="halloween-leaf"
          style={{
            left: `${leaf.left}%`,
            animationDuration: `${leaf.animationDuration}s`,
            animationDelay: `${leaf.animationDelay}s`,
            fontSize: `${leaf.size * 22}px`,
            opacity: leaf.opacity,
          }}
        >
          {leaf.emoji}
        </div>
      ))}
    </div>
  );
};

export default FallingLeaves;
